export default "__VITE_ASSET__D$rl79ZM__"